import React from 'react'
import { useTranslate } from 'react-admin'
import { Box, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Typography } from '@mui/material'
import { numberFormatterWithDecimalAndThousand } from 'src/helper/numberFormatterWithDecimalAndThousand'

export const HepstarTab = ({ product, loading = false }) => {
  const translate = useTranslate()

  if (!product) return null

  const hep = product.form_ancillaries_hepstar || null
  if (!hep) return null

  const metaPurchaseNumber = hep?.MetaPurchaseNumber || null

  const packages = Array.isArray(hep?.Package) ? hep.Package : []

  const rows = packages.map((pkg, index) => {
    const info = pkg?.PricedProduct?.ProductInformation || {}
    const priceBreakdown = pkg?.PricedProduct?.ProductPriceBreakdown || []
    const converted = Array.isArray(priceBreakdown)
      ? priceBreakdown.find((p) => p.Type === 'ConvertedCurrency') || priceBreakdown[0]
      : null

    const amount = converted?.TotalAmountConverted ?? converted?.TotalAmount ?? hep?.HepstarTotalAmount ?? 0
    const currency = converted?.Currency || (Array.isArray(priceBreakdown) && priceBreakdown[0]?.Currency) || ''

    return {
      id: pkg?.ID || index,
      title: info?.ProductIdentifier || info?.ProductCode || '—',
      amount,
      currency,
    }
  })

  if (rows.length === 0) return null

  return (
    <Box padding={2}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography className='keyText' component='div' color='text.primary'>
                  {translate('ra.field.product')}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography className='keyText' component='div' color='text.primary'>
                  {translate('ra.field.purchase_code')}
                </Typography>
              </TableCell>
              <TableCell align='right'>
                <Typography className='keyText' component='div' color='text.primary'>
                  {translate('ra.field.amount_earned')}
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((r, i) => (
              <TableRow key={r.id} sx={{ borderBottom: '1px solid rgba(0,0,0,0.12)' }}>
                <TableCell>
                  <Typography
                    className='valueText'
                    component='div'
                    color='text.primary'
                    style={{ overflowWrap: 'break-word' }}
                  >
                    {r.title}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    className='valueText'
                    component='div'
                    color='text.primary'
                    style={{ overflowWrap: 'break-word', fontFamily: 'monospace' }}
                  >
                    {metaPurchaseNumber || '—'}
                  </Typography>
                </TableCell>
                <TableCell align='right'>
                  <Typography
                    className='valueText'
                    component='div'
                    color='text.primary'
                    style={{ overflowWrap: 'break-word' }}
                  >
                    {r.currency ? `${r.currency} ` : ''}
                    {numberFormatterWithDecimalAndThousand(r.amount)}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default HepstarTab
